import { useDispatch } from "react-redux";
import {
  useProfileQuery,
} from "../pages/users/profileSlice";

export const useSecureApplication = () => {
  const { data: profileApi } = useProfileQuery();

  const hasAnyPerm = (...permissions: string[]): boolean => {
    return !!(
      profileApi &&
      profileApi.permissions &&
      !profileApi.permissions.every((p) => !permissions.includes(p))
    );
  };


  return {
    hasAnyPerm: hasAnyPerm,
  };
};
